<script setup lang="ts">
import BeamQualityTable from './BeamQualityTable.vue';
import VeeNumberField from '@/components/forms/NumberField/VeeNumberField.vue';
import {
  LinearAcceleratorDto,
  OtherMvTherapyMachineDto,
  RadiationType,
  instanceOfLinearAcceleratorDto,
} from '@/api/generator';
import { useFormValues } from 'vee-validate';
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import { I18nKey } from '@/utils/typings';

const values = useFormValues<LinearAcceleratorDto | OtherMvTherapyMachineDto>();
</script>

<template>
  <v-row>
    <v-col cols="4">
      <h5>{{ $t('Beam') }}</h5>
      <FormLabel class="gutterTop" :label="$t('BeamProduction')">{{
        $t(`MedicalSystemBeamProductionEnum.${values.beamProduction}` as I18nKey)
      }}</FormLabel>
      <FormLabel class="gutterTop" :label="$t('BeamLimitingDeviceType')">{{
        $t(`MedicalSystemBeamLimitingDeviceTypeEnum.${values.beamLimitingDeviceType}` as I18nKey)
      }}</FormLabel>
    </v-col>
    <v-col cols="3">
      <h5>{{ $t('Mechanical') }}</h5>

      <VeeNumberField
        class="gutterTop"
        :style="{ width: '160px' }"
        name="sourceAxisDistance"
        :placeholder="$t('Required')"
        :label="$t('SourceToAxisDistance')"
        suffix="mm"
      />
    </v-col>
  </v-row>

  <BeamQualityTable
    v-if="instanceOfLinearAcceleratorDto(values) && values.beamQualitiesPhoton?.visible"
    name="beamQualitiesPhoton"
    :type="RadiationType.Photon"
  />

  <BeamQualityTable
    v-if="instanceOfLinearAcceleratorDto(values) && values.beamQualitiesElectron?.visible"
    name="beamQualitiesElectron"
    :type="RadiationType.Electron"
  />
</template>

<style scoped lang="scss">
:deep(.display) {
  text-align: left;
}
:deep(.justify-space-between) {
  text-align: left;
  justify-content: start !important;
}
:deep(.flex-grow-1) {
  flex-grow: inherit !important;
}
</style>
